<!-- FILTERS -->
<div class="audit-filters-container">

  <!-- first row: calendar + all inputs + actions (in same grid) -->
  <div class="audit-filters-row">

    <!-- Module -->
    <div class="audit-filter-item audit-filter-module">
      <app-basic-dropdown
        class="form-select"
        width="200px"
        size="medium"
        [(model)]="auditFilters.moduleKey"
        [items]="modulesModel"
        (modelChange)="onModuleChanged()"
        bindLabel="moduleName"
        bindValue="moduleKey"
        label="{{ 'users:audit_module' | i18next : { defaultValue: 'Module' } }}"
        placeholder="{{ 'audit:changedlog_selectmodule' | i18next : { defaultValue: 'Select module' } }}"
        [clearable]="false"
        [searchable]="false">
      </app-basic-dropdown>
    </div>

    <!-- Name of module -->
    <div class="audit-filter-item">
      <app-basic-textbox
        [(model)]="auditFilters.moduleName"
        type="text"
        width="200px"
        label="{{ 'users:audit_moduleName' | i18next : { defaultValue: 'Name of module' } }}"
        size="medium"
        class="switch-time-textbox"
        [disabled]="auditFilters.moduleKey == '-1'">
      </app-basic-textbox>
    </div>

    <!-- Type of change -->
    <div class="audit-filter-item">
      <app-basic-dropdown
        class="form-select"
        width="200px"
        size="medium"
        [(model)]="auditFilters.operationKey"
        [items]="operations"
        bindLabel="operationName"
        bindValue="operationKey"
        label="{{ 'users:audit_typeOfChange' | i18next : { defaultValue: 'Type of change' } }}"
        [disabled]="auditFilters.moduleKey === '-1' || operations.length === 0"
        placeholder="{{ 'users:selectOperation' | i18next : { defaultValue: 'Select operation' } }}"
        [clearable]="false"
        [searchable]="false">
      </app-basic-dropdown>
    </div>

    <!-- Change -->
    <div class="audit-filter-item">
      <app-basic-textbox
        [(model)]="auditFilters.changeText"
        type="text"
        width="200px"
        label="{{ 'audit:What' | i18next : { defaultValue: 'Change' } }}"
        size="medium"
        class="switch-time-textbox"
        [disabled]="auditFilters.moduleKey === '-1'">
      </app-basic-textbox>
    </div>

    <!-- Change by user -->
    <div class="audit-filter-item">
      <app-basic-textbox
        [(model)]="auditFilters.userName"
        type="text"
        width="200px"
        label="{{ 'audit:AuditBy' | i18next : { defaultValue: 'Change by user' } }}"
        size="medium"
        class="switch-time-textbox">
      </app-basic-textbox>
    </div>

    <!-- Calendar -->
    <div class="audit-filter-item audit-filter-calendar">
      <div class="label">
        {{ 'users:audit_calendar' | i18next : { defaultValue: 'Calendar' } }}
      </div>

      <app-basic-date-range-picker
        [showTitle]="false"
        [initialPreset]="'yesterday'"
        [minDate]="minAuditDate"
        (rangeChange)="onCalendarRangeChange($event)">
      </app-basic-date-range-picker>
    </div>

    <!-- Actions: message + buttons now part of the grid -->
    <div class="audit-filters-actions">
      <div class="audit-filters-message" [ngClass]="{ 'warning': isMaxResultsWarning }">
        {{ maxResultsInfoMessage }}
      </div>

      <div class="audit-filters-buttons">
        <app-basic-button type="secondary" size="medium" (click)="onReset()">
          {{ 'users:reset' | i18next : { defaultValue: 'Reset' } }}
        </app-basic-button>

        <app-basic-button
          type="primary"
          size="medium"
          (click)="onSearchAudit()">
          {{ 'services:supervisor_search' | i18next : { defaultValue: 'Search' } }}
        </app-basic-button>
      </div>
    </div>

  </div>
</div>

<!-- error -->
<div *ngIf="errorMessage" class="table-error">
  {{ errorMessage }}
</div>

<!-- AUDIT TABLE -->
<ng-template #noData>
  <div class="no-items">
    {{ 'users:noresult' | i18next : { defaultValue: 'No results' } }}
  </div>
</ng-template>

<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<table
  mat-table
  [dataSource]="dataSource"
  matSort
  class="mat-elevation-z2 full-width-table"
>

  <!-- Date & Time -->
  <ng-container matColumnDef="logTime">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'users:audit_dateAndTime' | i18next : { defaultValue: 'Date and time' } }}
    </th>
    <td mat-cell *matCellDef="let a">
      {{ a.logTimeString }}
    </td>
  </ng-container>

  <!-- Module -->
  <ng-container matColumnDef="auditType">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'users:audit_module' | i18next : { defaultValue: 'Module' } }}
    </th>
    <td mat-cell *matCellDef="let a">
      {{ ('audit:lang_' + a.auditType) | i18next : { defaultValue: a.auditType } }}
    </td>
  </ng-container>

  <!-- Module Name -->
  <ng-container matColumnDef="moduleName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'users:audit_moduleName' | i18next : { defaultValue: 'Module name' } }}
    </th>
    <td mat-cell *matCellDef="let a" class="truncate-cell">
      {{ a.keyValue }}
    </td>
  </ng-container>

  <!-- What -->
  <ng-container matColumnDef="what">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'audit:What' | i18next : { defaultValue: 'What' } }}
    </th>
    <td mat-cell *matCellDef="let a" class="truncate-cell" style="max-width: 250px;">
      {{ a.message }}
    </td>
  </ng-container>

  <!-- Audit By -->
  <ng-container matColumnDef="auditBy">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'audit:AuditBy' | i18next : { defaultValue: 'Audit by' } }}
    </th>
    <td mat-cell *matCellDef="let a">
      {{ a.fullUserName }}
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" [attr.colspan]="displayedColumns.length">
      <ng-container *ngTemplateOutlet="noData"></ng-container>
    </td>
  </tr>
</table>
